import { isNumber, values } from 'lodash';

export const arrayToKeyValuePairs = (values: any[], shouldLowerCastValue = false) => {
  const arr = [];
  for (const value of values) {
    let formattedValue = value;
    if (shouldLowerCastValue && !isNumber(value)) {
      formattedValue = value.toLocaleLowerCase();
    }
    arr.push({ value: formattedValue, label: value.toString() });
  }
  return arr;
};

export const objectToKeyValuePairs = (obj: any, shouldLowerCastValue = false) => {
  return arrayToKeyValuePairs(values(obj), shouldLowerCastValue);
};
